<template>
  <div class="s-appointment" :style="{...bg.style,'background-image': `url(${bg.src})`}">
    <img :src="btnRule.src"  :style="{...btnRule.style}" alt="" @click="ruleShow"/>
    <img :src="getBtnImg(status)" alt="" @click="getBtnClick"  :style="{position: 'absolute', ...getPosition(btnStatusPosition), ...getSize(btnStatusSize)}">
    <div class="progress-box" :style="{position: 'absolute', ...getPosition(progressPosition), ...getSize(progressSize), 'background-color': progressColor}">
      <div class="progress-main">
        <div class="common-box-empty" :style="{visibility: 'hidden'}"/>
        <div v-for="(item,index) in numList" :key="index" class="common-box">
          <img v-if="item.num <= count" :src="progressCoinActive.src" :style="{...progressCoinActive.style}" alt=""/>
          <img v-else :src="progressCoin.src" :style="{...progressCoin.style}" alt=""/>
        </div>
      </div>
      <div class="progress-num">
        <div class="common-box-empty" :style="{visibility: 'hidden'}"/>
        <div v-for="(item,index) in numList" :key="index" class="common-box" :style="{'color': numColor}">{{Math.floor(item.num / 10000) + "w"}}</div>
      </div>
    </div>
    <ModalCommon ref="ModalCommon" title="活动规则">
      <div class="content" v-html="content"></div>
    </ModalCommon>
  </div>
</template>

<script>
import ModalCommon from "@/components/BuilderComponents/_components/ModalCommon.vue";
import { getPosition, getSize } from "@/components/BuilderComponents/utils";

export default {
  name: 'SAppointmentActivity',
  components: { ModalCommon },
  props: {
    request: {
      type: Function
    },
    appointmentId: {
      type: String,
      required: true
    },
    activityGId: {
      type: String,
      required: true
    },
    activityAId: {
      type: String,
      required: true
    },
    newId: {
      type: String,
      required: true
    },
    bg: {
      type: Object,
      required: true
    },
    btnRule: {
      type: Object,
      required: true
    },
    btnStatusSize: {
      type: String,
      required: true
    },
    btnStatusPosition: {
      type: String,
      required: true
    },
    btnNoAppointment: {
      type: Object,
      required: true
    },
    btnAppointment: {
      type: Object,
      required: true
    },
    btnNoReceive: {
      type: Object,
      required: true
    },
    btnReceived: {
      type: Object,
      required: true
    },
    btnExpire: {
      type: Object,
      required: true
    },
    progressSize: {
      type: String,
      required: true
    },
    progressPosition: {
      type: String,
      required: true
    },
    progressCoin: {
      type: Object,
      required: true
    },
    progressCoinActive: {
      type: Object,
      required: true
    },
    numList: {
      type: Array,
      required: true
    },
    progressColor: {
      type: String,
      required: true
    },
    numColor: {
      type: String,
      required: true
    },
    // ===== modal =====
    modalBg: {
      type: Object,
      default: () => {}
    },
    modalCloseIcon: {
      type: Object,
      default: () => {}
    },
    modalTitleStyle: {
      type: String,
      default: '{}'
    },
    modalTextStyle: {
      type: String,
      default: '{}'
    }
  },
  data () {
    return {
      content: "",
      count: 0,
      status: 0
    }
  },

  inject: {
    eventBus: {
      default: null
    }
  },
  provide () {
    return {
      $MainWrap: this
    }
  },
  computed: {
    requestAPI () {
      return this.request ? this.request : window.$request
    }
  },
  created () {
  },
  mounted () {
    // 获取活动规则
    this.getNewsDetailFunc()
    // 数据初始化->获取当前状态和当前进度
    this.getAppointmentInfoFunc()

    if (this.eventBus) {
      // 登录成功操作添加
      this.eventBus.on('loginSuccess', this.getAppointmentInfoFunc)
      // 登出操作添加
      this.eventBus.on('signOut', this.reset)
    }
  },
  methods: {
    // 获取状态按钮尺寸
    getSize,
    // 获取状态按钮位置
    getPosition,
    // 数据初始化->获取当前状态和当前进度
    getAppointmentInfoFunc() {
      this.requestAPI({
        url: '/v1/appointment-common/info',
        method: 'get',
        params: { a_id: this.appointmentId }
      }).then((res) => {
        this.status = res.status
        this.count = res.count
      }).catch((err) => {
        console.log(err)
        this.$message.error(err.msg || '系统错误')
      })
    },
    // 获取活动规则
    getNewsDetailFunc() {
      const params = {
        id: this.newId
      }
      this.requestAPI({
        url: '/api/news/detail',
        method: 'get',
        params
      }).then((res) => {
        this.content = res.content
      }).catch((err) => {
        console.log(err)
        this.$message.error(err.msg || '系统错误')
      })
    },
    // 规则展示
    ruleShow() {
      this.$refs.ModalCommon.open()
    },
    // 获取按钮状态图片
    getBtnImg(status) {
      const map = {
        0: this.btnNoAppointment.src,
        1: this.btnAppointment.src,
        2: this.btnNoReceive.src,
        3: this.btnReceived.src,
        4: this.btnExpire.src
      }
      return map[status];
    },
    // 按钮点击
    getBtnClick() {
      if (!window.$checkLogin()) return
      if (this.status === 0) {
        // 未预约
        this.getAppointmentFunc()
      } else if (this.status === 2) {
        // 未领取
        this.getAppointmentReceiveFunc()
      }
    },
    // 立即预约
    getAppointmentFunc() {
      if (!window.$checkLogin()) return
      this.requestAPI({
        url: '/v1/appointment-common/order',
        method: 'get',
        params: { a_id: this.appointmentId }
      }).then((res) => {
        this.$message({
          message: '预约成功',
          type: "success"
        })
        // 初始化数据
        this.getAppointmentInfoFunc()
      }).catch((err) => {
        console.log(err)
        this.$message.error(err.msg || '系统错误')
      })
    },
    // 立即领取
    getAppointmentReceiveFunc() {
      if (!window.$checkLogin()) return
      const params = {
        a_id: this.activityAId,
        g_id: this.activityGId
      }
      this.requestAPI({
        url: '/v1/uni/receive',
        method: 'get',
        params
      }).then((res) => {
        this.$message({
          message: '领取成功',
          type: "success"
        })
        // 初始化数据
        this.getAppointmentInfoFunc()
      }).catch((err) => {
        console.log(err)
        this.$message.error(err.msg || '系统错误')
      })
    },
    // 登出操作
    reset() {
      this.status = 0
      this.count = 0
    }
  }
}
</script>

<style lang="scss" scoped>
.bg-common {
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.s-appointment {
  position: relative;
  @extend .bg-common;
  .progress-box{
    .progress-main, .progress-num{
      width: 80%;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .progress-num{
      font-size: 24px;
      margin-top: 20px;
    }
    .common-box{
      display: flex;
      justify-content: center;
      align-items: center;
      width: 40px;
      img{
        width: 100%;
      }
    }
    .common-box-empty{
      width: 10px;
    }
  }
}
</style>
